import { render } from "./Tagtester.vue?vue&type=template&id=c01e3984"
import script from "./Tagtester.vue?vue&type=script&lang=js"
export * from "./Tagtester.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/tester.cl-planner.com/releases/62689321/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__